var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mapbox-image',{attrs:{"id":"pulsing-dot-image","src":_vm.pulsingDotImage,"options":{ pixelRatio: 2 }}}),_vm._v(" "),_c('mapbox-source',{attrs:{"id":"pulsing-dot","options":_vm.pulsingDotSource}}),_vm._v(" "),_c('mapbox-layer',{attrs:{"id":"pulsing-dot-layer","options":_vm.pulsingDotLayerOptions}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }